/* eslint-disable */
import React, { Dispatch, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import CancelIcon from '@material-ui/icons/Cancel';
import Grid from '@material-ui/core/Grid';
import BrandDetails from './BrandDetails';
import { addUserParameters, editUserParameters, sendEmail, storeBrandValues, subUserApproval, } from '../../store/actions/dealer.action';
import { API_ENDPOINTS } from "../../constants/apiConfig";
import moment from "moment-timezone";
import { ADD_PARAMS_BRANDS } from '../../constants/messages';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import { get } from 'lodash';
import { buildBrandsForUI, getNewBrand } from '../../common/components/util';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { FormControl, InputLabel, ListItemIcon, Select, TextField, Input, } from '@material-ui/core';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { getDealerDetails } from '../../store/actions/dealer.action';
import Switch from '@material-ui/core/Switch';
import RejectUserDialog from './RejectUserDialog';
import { getTabsForTierType } from '../../common/components/util';


export interface UsersParameterDialogProps {
  open: boolean;
  onClose: (value: boolean) => void;
  shipToPartyFeatureAccess: boolean;
  setUserApproved: any;
  userApproved: boolean
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`userdetail-tabpanel-${index}`}
      aria-labelledby={`userdetail-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>{children}</div>
      )}
    </div>
  );
}

function allTabProps(index: any) {
  return {
    id: `userdetail-tab-${index}`,
    'aria-controls': `userdetail-tabpanel-${index}`,
  };
}

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const BrandMenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };


const UsersParameterDialog: React.FC<UsersParameterDialogProps> = (props: UsersParameterDialogProps) => {
  const [brandName, setBrandName] = React.useState<string[]>([]);
  const [tabValue, setTabValue] = React.useState(0);
  const [shipToParty, setShipToParty] = React.useState<string>("");
  const [shipToPartyError, setShipToPartyError] = React.useState<boolean>(false);
  const [billToParty, setBillToParty] = React.useState<string>("");
  const [billToPartyError, setBillToPartyError] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  // const [userApproved, setUserApproved] = React.useState<boolean>(false);
  const [openRejectUserDialog, setOpenRejectUserDialog] = React.useState<boolean>(false);
  const [payerId, setPayerId] = React.useState<string>("");
  const [payerIdError, setPayerIdError] = React.useState<boolean>(false);
  const [sapCustomerId, setSapCustomerId] = React.useState<string>("");
  const [sapCustomerIdError, setSapCustomerIdError] = React.useState<boolean>(false);
  const [userParams, setUserParams] = React.useState<any>();
  const [isNewlyExtended, setIsNewlyExtended] = React.useState<any>(false);
  const [extendedBrand, setExtendBrand] = React.useState<any>([]);
  const [extendedBrandName, setExtendBrandName] = React.useState<any>([]);
  const [fillAtleastOneBrandDetail, setFillAtleastOneBrandDetail] = React.useState<any>(false);
  const [formSubmitted, setFormSubmitted] = React.useState<any>(false);
  const [partiallyCompleteBrandValidation, setPartiallyCompleteBrandValidation] = React.useState<any>([]);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [apiResponseText, setApiResponseText] = React.useState(false);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);
  const { shipToPartyNumber, usersList, dealerDetails, accessParam }: any = useSelector((state: any) => state.dealer);
  const userType = sessionStorage.getItem('userType');
  const dispatch: Dispatch<any> = useDispatch();
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const [shipToPartyAddressAPIResponse, setshipToPartyAddressAPIResponse] = React.useState<any>([]);
  const { accessDetails }: any = useSelector((state: any) => state.onboard);
  let featureAccessibility: any = accessParam?.data?.userAccessParameterData;
  const userTypeChoosenCustomer: any = sessionStorage.getItem('USER-TYPE-PARAM');

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    // if ((addParamInfo && addParamInfo.data) || (editParamInfo && editParamInfo.data)) {
    if ((accessParam && accessParam.data)) {
      featureAccessibility = accessParam?.data?.userAccessParameterData;
    }
  }, [accessParam]) // eslint-disable-line


  const isDisabled = () => {
    if (userType === 'afg_super_admin' || !props.userApproved) {
      return true;
    } else {
      return false;
    }
  }

  const AntSwitch = withStyles((theme: Theme) =>
    createStyles({
      root: {
        width: 60,
        height: 28,
        padding: 0,
      },
      switchBase: {
        padding: 5,
        color: '#FFFFFF',
      },
      thumb: {
        width: 17,
        height: 17,
      },
      track: {
        background: '#444444',
        opacity: '1 !important',
        borderRadius: '2rem',
        position: 'relative',
        '&:before, &:after': {
          display: 'inline-block',
          position: 'absolute',
          top: '50%',
          width: '50%',
          transform: 'translateY(-50%)',
          color: '#FFFFFF',
          textAlign: 'center',
          fontSize: 10,
          fontFamily: 'Nunito',
          fontWeight: 500
        },
        '&:before': {
          content: '"Yes"',
          left: 7,
          opacity: 0,
        },
        '&:after': {
          content: '"No"',
          right: 6,
        },
      },
      checked: {
        '&$switchBase': {
          color: '#FFFFFF',
          transform: 'translateX(33px)',
        },
        '& $thumb': {
          backgroundColor: '#FFFFFF',
        },
        '& + $track': {
          '&:before': {
            opacity: 1,
          },
          '&:after': {
            opacity: 0,
          }
        },
      },
    }),
  )(Switch);


  const webApplicationLoginId = get(profileDetails, 'data.data.basicInfo.webApplicationLoginId', "");
  const { userDetails, brandValues, addParamInfo, editParamInfo, userParameters }: any = useSelector((state: any) => state.dealer);
  const { brandsList }: any = useSelector((state: any) => state.dealer);

  const brands = React.useMemo(() => {
    return buildBrandsForUI(brandsList);
  }, [brandsList]);

  const formSubmittedRef = useRef(false);

  useEffect(() => {
    // if ((addParamInfo && addParamInfo.data) || (editParamInfo && editParamInfo.data)) {
    setOpenRejectUserDialog(false);
    if ((editParamInfo && editParamInfo.data)) {
      resetValues();
    }
  }, [editParamInfo]) // eslint-disable-line
  // }, [addParamInfo, editParamInfo]) // eslint-disable-line


  useEffect(() => {
    setOpenRejectUserDialog(false);
    const addressDetails: any = usersList && usersList.data && usersList.data.data && usersList.data.data.customerDetails && usersList.data.data.customerDetails.addresses && usersList.data.data.customerDetails.addresses.length > 0 && usersList.data.data.customerDetails.addresses.map((ele: any) => {
      return ele
    })
    if (addressDetails && addressDetails.length > 0) {
      const filteredShipToPartyAddress: any = addressDetails && addressDetails.filter((address: any) => {
        return address.shiftToPartyCustomerNumber === shipToParty
      })
      setshipToPartyAddressAPIResponse(filteredShipToPartyAddress);
    }
  }, [shipToParty, shipToPartyNumber, usersList])

  function resetValues() {
    setTabValue(0);
    setBrandName([]);
    setShipToParty('');
    setShipToPartyError(false);
    setBillToParty('');
    setOpenRejectUserDialog(false);
    setBillToPartyError(false);
    setPayerId('');
    props.setUserApproved(false);
    setPayerIdError(false);
    setSapCustomerId('');
    setSapCustomerIdError(false);
    dispatch(storeBrandValues(null));

  }
  // const isBrandActive = (brand: any, orgIds: any) => {
  //   // Iterate through the list of organizations
  //   if (brand && brand !== '' && orgIds && Array.isArray(orgIds) && orgIds.length > 0) {
  //     for (const org of orgIds) {
  //       // Check if the organizationId matches and isActive is true
  //       if (org.organizationId === brand && org.isActive) {
  //         return true;
  //       }
  //     }
  //   }
  //   // If no matching organizationId with isActive true is found, return false
  //   return false;
  // };


  const isBrandActive = (brand: any, orgIds: any): boolean => {
    if (brand && brand !== '' && orgIds && Array.isArray(orgIds) && orgIds.length > 0) {
      for (const org of orgIds) {
        // Check if the organizationId matches
        if (org.organizationId === brand) {
          // Check if isActive is true or missing (consider as true)
          // if (org.isActive === undefined || org.isActive === true) {
          if (org.isActive !== false) {
            return true;
          }
        }
      }
    }
    // If no matching organizationId with isActive true or missing is found, return false
    return false;
  };

  const isTyreAccess = () => {
    return featureAccessibility?.some((f: any) => f.featureCode === "ACCESS_TYRE" && f.value === true);

  }

  const isPartAccess = () => {
    return featureAccessibility?.some((f: any) => f.featureCode === "ACCESS_PART" && f.value === true);
  }

  useEffect(() => {
    if (!userDetails || formSubmittedRef.current) return;
    if (userDetails) {
      let isNewlyObject: any = userDetails?.salesOrganization?.some((obj: any) => obj.isNewlyExtendedBrand === true);
      setOpenRejectUserDialog(false);
      if (isNewlyObject) {

        let isNewlyExtended = false;
        let brands: any[] = []; // Array to hold all matching brands
        let brandNames: any[] = []; // Array to hold all corresponding brand names

        for (let i = 0; i < userDetails?.salesOrganization.length; i++) {
          if (userDetails?.salesOrganization[i].isNewlyExtendedBrand === true) {
            isNewlyExtended = true;
            brands.push(userDetails?.salesOrganization[i].organizationId);
            brandNames.push(userDetails?.salesOrganization[i].make);
          }
        }
        setIsNewlyExtended(isNewlyExtended);
        setExtendBrand(brands);
        setExtendBrandName(brandNames);
      } else {
        setIsNewlyExtended(false);
        setExtendBrand('');
        setExtendBrandName('');
      }
      let fetchedBrands: string[] = [];
      let brandValues: any = {};
      if (userParameters && userParameters.data && userParameters.data.data && userParameters.data.data.length > 0 && !formSubmittedRef.current) {
        let data = userParameters.data.data[0];
        // if (data.status === 'Active') {
        //   props.props.setUserApproved(true);
        // }
        setUserParams(data);
        let shipToParty = '';
        let billToParty = '';
        for (let item of data.organizationIds) {
          if (item.parameterAdded) {
            shipToParty = item.shipToParty;
            billToParty = item.billToParty;
            break
          };
        }
        setShipToParty(shipToParty);
        setBillToParty(billToParty);
        setSapCustomerId(data.sapCustomerId);
        setPayerId(data.payerId);
        const newBrands =
          userDetails?.salesOrganization
            ?.map(
              (item: any) => item.organizationId
            ) || [];

        const customerTierType =
          dealerDetails?.data?.data?.customerTierType || "";

        const isWorkshopOrTPCDealer =
          customerTierType === "Workshop" ||
          customerTierType === "tpcdealer";

        const tierConfig = getTabsForTierType(customerTierType);

        data.organizationIds.forEach((item: any) => {
          let fetchedBrand: any = "";

          if (item.hasOwnProperty("makeSubType")) {
            fetchedBrand = item;
          } else {
            fetchedBrand = item;

            // Workshop / tpcdealer
            if (isWorkshopOrTPCDealer) {
              const matchedConfig = tierConfig.find(
                (config: any) => config.id === item.salesOrganization
              );

              if (matchedConfig) {
                fetchedBrand = {
                  ...item,
                  make: matchedConfig.make,
                  label: matchedConfig.label,
                  // salesOffice: matchedConfig.salesOffice?.[0] || "",
                  // salesOfficeKey: matchedConfig.salesOfficeKey || "",
                  salesOffice: matchedConfig.salesOffice?.[0] || item.salesOffice || "",

                };
              }
            }
          }

          const brandKey = isWorkshopOrTPCDealer
            ? fetchedBrand.make
            : fetchedBrand?.makeSubType
              ? fetchedBrand.makeSubType
              : fetchedBrand?.salesOffice
                ? fetchedBrand.salesOffice
                : fetchedBrand?.make;

          if (fetchedBrand && fetchedBrand.make !== "") {
            fetchedBrands.push(brandKey);
          }

          if (fetchedBrand) {
            Object.assign(brandValues, {
              [brandKey]: {
                make: fetchedBrand.make,
                salesOrganization: fetchedBrand.salesOrganization || "",
                salesOffice: fetchedBrand.salesOffice || "",
                distributionChannel: fetchedBrand.distributionChannel || "",
                division: fetchedBrand.division || "",
                allowIpPattern: fetchedBrand.allowIpPattern || "",
                salesGroup: fetchedBrand.salesGroup || "",
                salesEmployee: fetchedBrand.salesEmployee || "",
                creditControlArea: fetchedBrand.creditControlArea || "",
                status: !props.userApproved && data.userType !== "Admin"
                  ? "deActive"
                  : fetchedBrand.status || item.status,
                assignKam: fetchedBrand.assignKam || "",
                sapUserId: fetchedBrand.sapUserId || "",
                id: fetchedBrand.id || "",
                ...(fetchedBrand.makeSubType && {
                  makeSubType: fetchedBrand.makeSubType
                })
              }
            });
          }
        });
      }
      dispatch(storeBrandValues(brandValues));
      setBrandName(fetchedBrands);
    }
  }, [userDetails, dealerDetails, userParameters, props.userApproved, accessParam]);

  const resetValuesOnClickCancel = () => {
    setPartiallyCompleteBrandValidation(false);
    setFillAtleastOneBrandDetail(false);
    setSapCustomerIdError(false);
    setShipToPartyError(false);
    setPayerIdError(false);
    setBillToPartyError(false);
    setFormSubmitted(false);
    props.setUserApproved(false);

  }
  const emailLinkOnAddUserParam = (createDealerUser: any) => {
    if (createDealerUser && createDealerUser.data) {
      if (createDealerUser.data.sendLink) {
        const data = {
          "fromAddress": "tradepoint@alfuttaim.com",
          "toAddress": createDealerUser.data.email,
          "subject": "Account Verification and Self-Registration",
          "senderName": "Auto B2B",
          "templateName": "B2B_CUSTOMER_INVITE",
          "templateData": {
            "DateOfMail": moment(new Date()).format("DD/MM/YYYY"),
            "Url": `${API_ENDPOINTS.ON_BOARDING_URL}/signup?b2bUserId=${createDealerUser.data.b2bUserId}`,
            "CustomerName": "",
            //createDealer && createDealer.data && createDealer.data.data ? `${createDealer.data.data.data.title} ${createDealer.data.data.data.companyName}` : '',
            "Name": `${createDealerUser.data.firstName} ${createDealerUser.data.lastName}`
          }
        }
        dispatch(sendEmail(data));
      }
    }
  }

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  // const handleBrandChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   setBrandName(event.target.value as string[]);
  // };

  const handleInputChange = (e: any, setterName: any, errorSetterName?: any) => {
    setterName(e.target.value);
    if (errorSetterName && e.target.required) {
      const regex = /^[0-9 \b]+$/
      if (!regex.test(e.target.value)) {
        errorSetterName(true);
      } else if (e.target.value === "" || e.target.value.trim() === "")
        errorSetterName(true);
      else
        errorSetterName(false);
    }
  }

  function validateDetails() {
    let isValid: boolean = true;
    if (sapCustomerId.trim() === "") {
      setSapCustomerIdError(true);
      isValid = false;
    }
    if (shipToParty.trim() === "") {
      setShipToPartyError(true);
      isValid = false;
    }
    if (payerId.trim() === "") {
      setPayerIdError(true);
      isValid = false;
    }
    if (billToParty.trim() === "") {
      setBillToPartyError(true);
      isValid = false;
    }
    return isValid;
  }



  function brandFieldCount(brandValues: any) {
    let requiredCount = 0;
    if (Object.keys(brandValues).length > 1) {
      if (brandValues.creditControlArea.trim() === "") {
        requiredCount += 1;
      }
      if (brandValues.distributionChannel.trim() === "") {
        requiredCount += 1;
      }
      if (!brandValues.makeSubType) {
        if (brandValues.division.trim() === "") {
          requiredCount += 1;
        }
      }
      if (brandValues.salesOffice.trim() === "") {
        requiredCount += 1;
      }
      if (brandValues.salesGroup.trim() === "") {
        requiredCount += 1;
      }
      // if (brandValues.salesEmployee.trim() === "") {
      //   requiredCount += 1;
      // }
      // if(brandValues.assignKam.trim() === ""){
      //   requiredCount += 1;
      // }
    }
    return requiredCount
  }

  function brandFieldDetailsCheck(brandValues: any) {
    let validated = 0;
    if (Object.keys(brandValues).length > 1) {
      if (brandValues.creditControlArea.length !== 4 && brandValues.creditControlArea.length !== 0) {
        validated += 1;
      }
      if (brandValues.distributionChannel.length !== 2 && brandValues.distributionChannel.length !== 0) {
        validated += 1;
      }
      if (!brandValues.makeSubType) {
        if (brandValues.division.length !== 2 && brandValues.division.length !== 0) {
          validated += 1;
        }
      }

      if (brandValues.salesOffice.length !== 4 && brandValues.salesOffice.length !== 0) {
        validated += 1;
      }
      if (brandValues.salesGroup.length !== 3 && brandValues.salesGroup.length !== 0) {
        validated += 1;
      }
      if (brandValues.salesEmployee.length !== 6 && brandValues.salesEmployee.length !== 0) {
        validated += 1;
      }
      // if (brandValues.assignKam.length !== 6 && brandValues.assignKam.length !== 0) {
      //   validated += 1;
      // }
    }
    return validated
  }

  function getAddParamData() {
    let selectedBrands: any[] = [];

    Object.values(brandValues).forEach((element: any) => {
      element.shipToParty = shipToParty.trim();
      element.billToParty = billToParty.trim();
      selectedBrands.push(element);
    });

    let payload: any = {
      "sessionDetails": {
        "clientIPAddress": sessionStorage.getItem('clientIp'),
        "webApplicationLoginId": webApplicationLoginId,
      },
      "b2bUserId": userDetails.b2bUserId,
      "sapCustomerId": sapCustomerId.trim(),
      "payerId": payerId.trim(),
      "organizationIds": selectedBrands.filter((brand: any) => brand),
      "customerTierType": sessionStorage.getItem('itemCustomerTierType')
    }

    if (sessionStorage.getItem('itemCustomerTierType') === "TBL Dealer" || sessionStorage.getItem('itemCustomerTierType') === "Dealer") {
      let userIdExist: any = [];
      let orgIds = payload.organizationIds.map((item: any) => {
        const { division, sapUserId } = item;
        if (division === "90") {
          userIdExist.push(sapUserId)
        }
        if (division === "99") {
          if (userIdExist.includes(sapUserId)) {
            item.sapUserId = ""
          }
        }
        return item;
      });
      // orgIds = orgIds.filter((item: any) => item.division ? true : false)
      payload.organizationIds = orgIds;
    }

    return payload;
  }


  async function getEditParamData() {
    let selectedBrands: any = [];
    let selectedBrandNames: any = [];

    // Collect all selected brands and their names
    Object.values(brandValues).forEach((element: any) => {
      element.shipToParty = shipToParty.trim();
      element.billToParty = billToParty.trim();
      selectedBrands.push(element);
      selectedBrandNames.push(element.make);
    });

    if (isNewlyExtended && extendedBrandName && extendedBrandName.length > 0) {
      let newData: any = [];

      // Iterate over each brand name in extendedBrandName
      extendedBrandName.forEach((brandName: any) => {
        // Filter selected brands for the current brandName
        let brandData = selectedBrands.filter((brand: any) => brand.make === brandName);

        // Check if all specified fields are not empty for the current brand
        let allFieldsFilled = brandData.every((brand: any) =>
          brand.salesOffice !== '' &&
          brand.distributionChannel !== '' &&
          brand.division !== '' &&
          brand.salesGroup !== '' &&
          brand.creditControlArea !== ''
        );

        if (allFieldsFilled) {
          newData.push(...brandData);
        } else {
          // If not all fields are filled, push the first brand data with any filled fields
          let partiallyFilledBrand = brandData.find((brand: any) =>
            brand.salesOffice !== '' ||
            brand.distributionChannel !== '' ||
            brand.division !== '' ||
            brand.salesGroup !== '' ||
            brand.creditControlArea !== ''
          );

          if (partiallyFilledBrand) {
            newData.push(partiallyFilledBrand);
          }
        }
      });
      setLoading(true);
      if (newData.length > 0) {
        let data: any = {
          sessionDetails: {
            webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
            clientIPAddress: sessionStorage.getItem('clientIp')
          },
          isNewlyExtendedBrand: isNewlyExtended,
          b2bUserId: userDetails.b2bUserId,
          payerId: payerId.trim(),
          organizationIds: newData,
          customerTierType: sessionStorage.getItem('itemCustomerTierType')
        };

        let userData = await dispatch(addUserParameters(data)); // POST call for newly added SAP brand

        if (isNewlyExtended) {
          dispatch(getDealerDetails(sapCustomerId, 'dealerDetails'));
        }

        emailLinkOnAddUserParam(userData);
        setLoading(false);
        // resetValuesOnClickCancel();
      }
    }

    // Prepare editData for editing user parameters
    let editData: any = {
      sessionDetails: {
        webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
        clientIPAddress: sessionStorage.getItem('clientIp')
      },
      b2bUserId: userDetails.b2bUserId,
      payerId: payerId.trim(),
      organizationIds: extendedBrandName && isNewlyExtended ?
        selectedBrands.filter((brand: any) => !extendedBrandName.includes(brand.make)) :
        selectedBrands,
      customerTierType: sessionStorage.getItem('itemCustomerTierType')
    };
    if (sessionStorage.getItem('itemCustomerTierType') === "TBL Dealer" || sessionStorage.getItem('itemCustomerTierType') === "Dealer") {
      let userIdExist: any = [];
      let orgIds = editData.organizationIds.map((item: any) => {
        const { division, sapUserId } = item;
        if (division === "90") {
          userIdExist.push(sapUserId)
        }
        if (division === "99") {
          if (userIdExist.includes(sapUserId)) {
            item.sapUserId = ""
          }
        }
        return item;
      });
      editData.organizationIds = orgIds;
    }
    setLoading(true);
    let data: any = await dispatch(editUserParameters(editData)); // PUT call existing feature
    if (data && data.data) {
      formSubmittedRef.current = false;
      setLoading(false);
      resetValuesOnClickCancel();
    }
  }

  function checkBrandValidation(): string {

    const brandTabs = Object.values(brandValues || {});

    const requiredFields = [
      "salesOffice",
      "distributionChannel",
      "salesGroup",
      "salesEmployee",
      "creditControlArea"
    ];

    let hasCompletedTab = false;
    let hasPartialTab = false;

    for (const tab of brandTabs as any[]) {

      if (!tab) continue;

      const filledCount = requiredFields.filter(
        (field) =>
          tab[field] &&
          typeof tab[field] === "string" &&
          tab[field].trim() !== ""
      ).length;

      if (filledCount === 0) {
        continue;
      }

      if (filledCount === requiredFields.length) {
        hasCompletedTab = true;
      } else {
        hasPartialTab = true;
      }
    }

    // all empty
    if (!hasCompletedTab && !hasPartialTab) {
      setFillAtleastOneBrandDetail(true);
      setPartiallyCompleteBrandValidation([]);
      return "allEmpty";
    }

    // partial only, no completed tab
    if (!hasCompletedTab && hasPartialTab) {
      setFillAtleastOneBrandDetail(false);
      setPartiallyCompleteBrandValidation(["Please complete atleast one tab"]);
      return "partiallyEmpty";
    }

    // atleast one full tab exists -> allow
    setFillAtleastOneBrandDetail(false);
    setPartiallyCompleteBrandValidation([]);

    return "";
  }
  const saveParameters = async () => {


    formSubmittedRef.current = true;
    setFormSubmitted(true);

    let brandValidation = checkBrandValidation();

    if (
      validateDetails() &&
      !brandValidation
    ) {

      setLoading(true);

      if (userDetails.status === 'Active') {

        await getEditParamData();

        setLoading(false);
        resetValuesOnClickCancel();

      } else {

        let paramsData = getAddParamData();

        let userData: any = await dispatch(addUserParameters(paramsData));

        emailLinkOnAddUserParam(userData);

        setLoading(false);

        if (userData && userData.data) {

          formSubmittedRef.current = false;

          resetValues();
          resetValuesOnClickCancel();
        }
      }

    } else {

      formSubmittedRef.current = false;

    }
  }

  const rejectSubUser = (msg: any) => {
    const payload: any = {
      "recordId": userDetails.id,
      "kamApprovalStatus": false,
      "kamRejectionMsg": msg,
      "sapCustomerId": userDetails.sapCustomerId,
      "webApplicationLoginId": userDetails.webApplicationLoginId
    }
    const data: any = dispatch(subUserApproval(payload));
    setOpenRejectUserDialog(false);
    props.setUserApproved(false);
  }

  const selectedFieldProps: any = {
    IconComponent: <i className="material-icons">more_vert</i>,
  }

  return (
    <Dialog
      open={props.open ? true : false}
      onClose={() => { props.onClose(false); resetValuesOnClickCancel(); }}
      fullWidth={true}
      className='quotation'
      maxWidth={'md'}
      disableEscapeKeyDown>
      {loading && <FullscreenLoader />}
      {shipToPartyNumber && shipToPartyNumber.loading && <FullscreenLoader />}
      {userParameters && userParameters.loading && <FullscreenLoader />}
      <DialogTitle className="pb-0" id="form-dialog-title">
        <div className="page-title">
          {userType === 'afg_super_admin' ? 'View Parameter' : (
            <>
              {userDetails && userDetails.status === 'Active' ? 'Edit Parameter' : 'Add Parameter'}
            </>
          )}
          {addParamInfo && addParamInfo.err && addParamInfo.err.error && addParamInfo.err.error.statusText && addParamInfo.err.error.statusText.data && (
            <span style={{ color: 'red', fontSize: '14px' }}> <ErrorOutlineOutlinedIcon /> {addParamInfo.err.error.statusText.data.message.message}</span>
          )}
          {editParamInfo && editParamInfo.err && editParamInfo.err.error && editParamInfo.err.error.statusText && editParamInfo.err.error.statusText.data && (
            <span style={{ color: 'red', fontSize: '14px' }}> <ErrorOutlineOutlinedIcon /> {editParamInfo.err.error.statusText.data.message.message}</span>
          )}
          <IconButton aria-label="close" className="float-right" onClick={() => { props.onClose(false); resetValuesOnClickCancel() }}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="p-0">
        <div className="p-0">
          {userParams && (
            <Grid container className="user-details-bg pl-4 pt-3 pb-3">
              <Grid item xs={6} sm={4}>
                <span className="info-text">Name: </span>
                <span className="dealer-table-content">{userParams.title}{' '}{userParams.firstName}{' '}{userParams.lastName}</span>
              </Grid>
              <Grid item xs={6} sm={4}>
                <span className="info-text">Email: </span>
                <span className="dealer-table-content">{userParams.email}</span>
              </Grid>
              <Grid item xs={6} sm={4}>
                <span className="info-text">Mobile: </span>
                <span className="dealer-table-content">{userParams.mobileNumber}</span>
              </Grid>
              <Grid item xs={6} sm={4}>
                <span className="info-text">Dealer: </span>
                <span className="dealer-table-content">{userParams.companyTitle}{' '}{userParams.companyName}</span>
              </Grid>
              <Grid item xs={6} sm={4}>
                <span className="info-text">User ID: </span>
                <span className="dealer-table-content">{userParams.webApplicationLoginId}</span>
              </Grid>
              <Grid item xs={6} sm={4}>
                <span className="info-text">Status: </span>
                <span className="dealer-table-content">{userParams.status}</span>
              </Grid>
              <Grid item xs={12} sm={12}>
                {userDetails && userDetails.status !== 'Active' && userDetails.userType !== "Admin" && (
                  <>
                    <div className='font-weight-600 mt-2'>Justification</div>
                    <span>{userParams?.justificationMsg}</span>
                    <Grid container alignItems="center" spacing={2} className="mt-2">
                      <Grid item>
                        <span className='mr-2'>User Approved</span>
                      </Grid>
                      <Grid item>
                        <AntSwitch
                          checked={props.userApproved}
                          onChange={(e: any) => {
                            props.setUserApproved(e.target.checked)
                          }}
                        />
                      </Grid>
                      {!props.userApproved && (
                        <Grid item>
                          <Button variant="contained" color="secondary"
                            className="rounded-button-dealer" onClick={() => setOpenRejectUserDialog(true)} >Reject User</Button>
                        </Grid>
                      )}
                    </Grid>
                  </>
                )
                }
              </Grid >
            </Grid >

          )}
          {
            shipToPartyAddressAPIResponse && shipToPartyAddressAPIResponse.length > 0 && shipToPartyAddressAPIResponse.map((ele: any) => {
              return <>
                <h4 className="dealer-table-content ml-4 mt-2 mb-2">Shipping Address Details :</h4>
                <Grid container className="user-details-bg pl-4 pt-3 pb-3">
                  <Grid item xs={6} sm={4}>
                    <span className="info-text">Name of Location: </span>
                    <span className="dealer-table-content">{ele && ele.location ? ele.location : '-'}</span>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <span className="info-text">City: </span>
                    <span className="dealer-table-content">{ele && ele.city ? ele.city : '-'}</span>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <span className="info-text">Street Name: </span>
                    <span className="dealer-table-content">{ele && ele.streetName ? ele.streetName : '-'}</span>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <span className="info-text">Transportation Zone: </span>
                    <span className="dealer-table-content">{ele && ele.transportationZone ? ele.transportationZone : '-'}</span>
                  </Grid>
                </Grid>
              </>
            })
          }
          <Grid container className="p-4">
            <Grid item xs={6}>
              <TextField
                required
                value={sapCustomerId}
                disabled={isDisabled() ? isDisabled() : sapCustomerId ? true : false}
                id="sapCustomerId"
                error={sapCustomerIdError}
                label="Customer No."
                onChange={(e: any) => handleInputChange(e, setSapCustomerId, setSapCustomerIdError)}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    {(sapCustomerId && !sapCustomerIdError) && <CheckCircleIcon className="valid-user-id" />}
                    {(sapCustomerId && sapCustomerIdError) && <CancelIcon color="secondary" />}</InputAdornment>,
                }}
                className="rounded-input-dealer w-100 pr-4 pb-2"
                margin="dense" variant="outlined" />
            </Grid>
            {props.shipToPartyFeatureAccess ? (<Grid item xs={6}>
              <FormControl margin="dense" required className="commonRoundedInputs w-100" variant="outlined">
                <InputLabel id="companyBrandsLabel" className="label-formField" >Ship to party</InputLabel>
                <Select
                  variant="outlined"
                  id="shipToParty"
                  value={shipToParty}
                  error={shipToPartyError}
                  disabled={isDisabled()}
                  className="dropdown"
                  onChange={(e: any) => handleInputChange(e, setShipToParty, setShipToPartyError)}
                  input={<OutlinedInput label="Ship to Party" />}
                  renderValue={() => shipToParty}
                >
                  {shipToPartyNumber && shipToPartyNumber.data && shipToPartyNumber.data.data && shipToPartyNumber.data.data.shipToPartyNumber && shipToPartyNumber.data.data.shipToPartyNumber.map((item: any) => (
                    <MenuItem className="menu-dropdown" value={item && item.shipToPartyNumber} key={item && item.shipToPartyNumber}>
                      {item.shipToPartyNumber}
                      {item.selecteddefaultAddressId
                        && <Button
                          className="defaultAddressButton cursor-default ml-3"
                          size="small"
                          variant="contained"
                          color="secondary"
                        >Assigned Address</Button>}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            ) : (
              <Grid item xs={6}>
                <TextField required
                  value={shipToParty}
                  id="shipToParty"
                  onChange={(e: any) => handleInputChange(e, setShipToParty, setShipToPartyError)}
                  disabled={isDisabled()}
                  error={shipToPartyError}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">
                      {shipToParty && !shipToPartyError && <CheckCircleIcon className="valid-user-id" />}
                      {(shipToParty && shipToPartyError) && <CancelIcon color="secondary" />}</InputAdornment>,
                  }}
                  label="Ship to Party" className="rounded-input-dealer w-100 pb-2" margin="dense" variant="outlined" />
              </Grid>
            )}


            <Grid item xs={6}>
              <TextField required
                value={payerId}
                id="payerId"
                error={payerIdError}
                inputProps={{ maxLength: 10 }} // restrict input to 10 chars
                disabled={isDisabled()}
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    {payerId && !payerIdError && <CheckCircleIcon className="valid-user-id" />}
                    {(payerId && payerIdError) && <CancelIcon color="secondary" />}</InputAdornment>,
                }}

                onChange={(e: any) => handleInputChange(e, setPayerId, setPayerIdError)}
                label="Payer" className="rounded-input-dealer w-100 pr-4 pb-2" margin="dense" variant="outlined" />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                value={billToParty}
                id="billToParty"
                error={billToPartyError}
                disabled={isDisabled()}
                label="Bill to Party"
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    {billToParty && !billToPartyError && <CheckCircleIcon className="valid-user-id" />}
                    {(billToParty && billToPartyError) && <CancelIcon color="secondary" />}</InputAdornment>,
                }}
                onChange={(e: any) => handleInputChange(e, setBillToParty, setBillToPartyError)}
                className="rounded-input-dealer w-100 pb-2"
                margin="dense" variant="outlined" />
            </Grid>
            {/* <Grid item xs={12}>
              <FormControl required className="rounded-input-dealer w-100 mt-2" variant="outlined">
                <InputLabel id="companyBrandsLabel">Select Brands (Multiselect)</InputLabel>
                <Select
                  disabled
                  labelId="companyBrandsLabel"
                  id="companyBrandsSelect"
                  // error={brandNamesError}
                  multiple
                  variant="outlined"
                  value={brandName}
                  onChange={handleBrandChange}
                  input={<Input id="companyBrandsInput" />}
                  renderValue={(selected) => (
                    <div>
                      {(selected as string[]).map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </div>
                  )}
                  MenuProps={BrandMenuProps}
                >
                  {brands.map((item) => (
                    <MenuItem key={item.organizationId} value={item.make}>
                      {item.make}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}
          </Grid>
          {fillAtleastOneBrandDetail && <div style={{ textIndent: '20px', color: 'red', fontWeight: 600 }}>{ADD_PARAMS_BRANDS.NO_DETAILS}</div>}
          {partiallyCompleteBrandValidation.length > 0 && <div style={{ paddingLeft: '20px', paddingRight: '20px', color: 'red', fontWeight: 600 }}><div>{ADD_PARAMS_BRANDS.PLEASE_COMPLETE} {partiallyCompleteBrandValidation.length === 1 ? partiallyCompleteBrandValidation.map((brand: any) => <span>{getNewBrand(brand) === 'Tradepoint' && sessionStorage.getItem('itemCustomerTierType') !== 'Workshop' && sessionStorage.getItem('itemCustomerTierType') !== 'tpcdealer' ? 'ALAC' : getNewBrand(brand)}</span>) : partiallyCompleteBrandValidation.map((brand: any, index: number) => <span>{getNewBrand(brand)}{index < partiallyCompleteBrandValidation.length - 1 ? " - " : ""}</span>)}.</div> <div>*Note: {sessionStorage.getItem('itemCustomerTierType') !== "TBL Dealer" && sessionStorage.getItem('itemCustomerTierType') !== "Dealer" ? ADD_PARAMS_BRANDS.OTHER_PANELS_EMPTY : ADD_PARAMS_BRANDS.OTHER_PANELS_EMPTY_DEALER}</div></div>}
          <Paper square style={{ marginTop: '-10px' }}>
            {/* <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" aria-label="Dealer Tab">
              {(sessionStorage.getItem('itemCustomerTierType') !== "TBL Dealer" && sessionStorage.getItem('itemCustomerTierType') !== "Dealer") && brandName && brandName.length > 0 && brandName.map((brand, index) => (
                <Tab label={getNewBrand(brand) === 'Tradepoint' && sessionStorage.getItem('itemCustomerTierType') !== 'Workshop' && sessionStorage.getItem('itemCustomerTierType') !== 'tpcdealer' ? 'ALAC' : getNewBrand(brand)} {...allTabProps(index)} key={index} />
              ))
              }
              {
                (sessionStorage.getItem('itemCustomerTierType') === "TBL Dealer" || sessionStorage.getItem('itemCustomerTierType') === "Dealer") && brandName && brandName.length > 0 && brandName.map((brand, index) => (
                  <Tab label={getNewBrand(brand) === 'Tradepoint' ? 'ALAC' : getNewBrand(brand)} {...allTabProps(index)} key={index} />
                ))
              }
            </Tabs> */}
            <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" aria-label="Dealer Tab">
              {/* CHANGED: Render tabs based on onboardingType config and match salesOrganization id */}
              {(() => {
                const customerTierType =
                  dealerDetails?.data?.data?.customerTierType || "";

                const isWorkshopOrTPCDealer =
                  customerTierType === "Workshop" ||
                  customerTierType === "tpcdealer";

                const tierConfig = getTabsForTierType(customerTierType);

                if (
                  tierConfig.length > 0 &&
                  userParameters?.data?.data?.[0]?.organizationIds
                ) {
                  const orgIds = userParameters.data.data[0].organizationIds;

                  return tierConfig
                    .filter((config: any) =>
                      orgIds.some((org: any) => {
                        // Workshop / tpcdealer → ignore salesOffice
                        if (isWorkshopOrTPCDealer) {
                          return org.salesOrganization === config.id;
                        }

                        // Other users → check salesOffice also
                        return (
                          org.salesOrganization === config.id &&
                          (config.salesOffice.length === 0 ||
                            config.salesOffice.includes(org.salesOffice))
                        );
                      })
                    )
                    .map((config: any, index: number) => (
                      <Tab label={config.label} {...allTabProps(index)} key={index} />
                    ));
                }
                // fallback to existing logic
                return brandName && brandName.length > 0 && brandName.map((brand, index) => (
                  <Tab
                    label={getNewBrand(brand) === 'Tradepoint' && sessionStorage.getItem('itemCustomerTierType') !== 'Workshop' && sessionStorage.getItem('itemCustomerTierType') !== 'tpcdealer' ? 'ALAC' : getNewBrand(brand)}
                    {...allTabProps(index)}
                    key={index}
                  />
                ));
              })()}
            </Tabs>
          </Paper>
          {/* {
            userParameters && userParameters.data && userParameters.data.data && userParameters.data.data.length > 0 && brandName && brandName.length > 0 && brandName.map((brand, index) => (
              <TabPanel value={tabValue} index={index} key={index}>
                <div className="p-4">
                  <BrandDetails make={brand} formSubmitted={formSubmitted} fillAtleastOneBrandDetail={fillAtleastOneBrandDetail} partiallyCompleteBrandValidation={partiallyCompleteBrandValidation} userApproved={props.userApproved} />
                </div>
              </TabPanel>
            ))
          } */}
          {/* CHANGED: Render TabPanels based on onboardingType config matching salesOrganization id */}
          {(() => {
            const customerTierType =
              dealerDetails?.data?.data?.customerTierType || "";

            const isWorkshopOrTPCDealer =
              customerTierType === "Workshop" ||
              customerTierType === "tpcdealer";

            const tierConfig = getTabsForTierType(customerTierType);

            if (
              tierConfig.length > 0 &&
              userParameters?.data?.data?.[0]?.organizationIds
            ) {
              const orgIds = userParameters.data.data[0].organizationIds;

              const matchedConfigs = tierConfig.filter((config: any) =>
                orgIds.some((org: any) => {
                  // For Workshop / tpcdealer → only check salesOrganization
                  if (isWorkshopOrTPCDealer) {
                    return org.salesOrganization === config.id;
                  }

                  // Other users → check salesOrganization + salesOffice
                  return (
                    org.salesOrganization === config.id &&
                    (config.salesOffice.length === 0 ||
                      config.salesOffice.includes(org.salesOffice))
                  );
                })
              );
              return matchedConfigs.map((config: any, index: number) => (
                <TabPanel value={tabValue} index={index} key={index}>
                  <div className="p-4">
                    <BrandDetails
                      make={isWorkshopOrTPCDealer ? config.make : config.salesOffice[0]}
                      // make={config.salesOffice[0] }
                      formSubmitted={formSubmitted}
                      fillAtleastOneBrandDetail={fillAtleastOneBrandDetail}
                      partiallyCompleteBrandValidation={
                        partiallyCompleteBrandValidation
                      }
                      userApproved={props.userApproved}
                    />
                  </div>
                </TabPanel>
              ));
            }
            // fallback to existing logic
            return userParameters?.data?.data?.length > 0 && brandName && brandName.length > 0 && brandName.map((brand, index) => (
              <TabPanel value={tabValue} index={index} key={index}>
                <div className="p-4">
                  <BrandDetails
                    make={brand}
                    formSubmitted={formSubmitted}
                    fillAtleastOneBrandDetail={fillAtleastOneBrandDetail}
                    partiallyCompleteBrandValidation={partiallyCompleteBrandValidation}
                    userApproved={props.userApproved}
                  />
                </div>
              </TabPanel>
            ));
          })()}
        </div >
      </DialogContent >
      <DialogActions className="my-2 mr-4">
        {userType !== 'afg_super_admin' && (
          <Button disabled={loading || (!props.userApproved && userTypeChoosenCustomer === "User")} variant="contained" color="secondary"
            className="rounded-button-dealer pl-4 pr-4" onClick={() => saveParameters()} >Save</Button>
        )}
        <Button variant="contained" className="rounded-button-dealer-cancel pl-4 pr-4" onClick={() => { props.onClose(false); resetValuesOnClickCancel(); }} >Cancel</Button>
      </DialogActions>
      <Snackbar
        open={openSnackbar}
        handleopenClose={() => {
          setOpenSnackbar(false)
        }} message={apiResponseText} />
      <RejectUserDialog
        open={openRejectUserDialog}
        maxWidth="sm"
        rejectUser={(msg: any) => rejectSubUser(msg)}
        handleopenClose={() => setOpenRejectUserDialog(false)}
      />
      <Snackbar
        open={openErrorSnackbar}
        type="error"
        handleopenClose={() => {
          handleopenCloseErrorSnackbar(false)
        }} message={errorMessage} />
    </Dialog >
  )
}

export default UsersParameterDialog;